import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { UrlTree } from '@angular/router';
import { RESPONSE } from '../../express.tokens';
import { Response } from 'express';

@Injectable({
  providedIn: 'root',
})
export class NotFoundGuard {
  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    @Optional() @Inject(RESPONSE) private response: Response
  ) {}

  async canActivate(): Promise<UrlTree | boolean> {
    if (isPlatformServer(this.platformId)) this.response.status(404);
    return true;
  }
}
